import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';


import { ProgramInformationComponent } from '../../schedule-appointment/program-information/program-information.component'

const programInformationRoutes: Routes = [
    {
        path: '',
        component: ProgramInformationComponent
    }
];

@NgModule({
    imports: [RouterModule.forChild(programInformationRoutes)],
    exports: [RouterModule],
})

export class ProgramInformationRoutingModule {
}